<template>
  <div class="areas-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-collage</v-icon>
          <div class="title-text">
            <h1 class="main-title">ÁREAS</h1>
            <p class="subtitle">Gestión de Áreas del Sistema</p>
          </div>
        </div>
        <div class="action-section">
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" class="create-btn" v-on="on" elevation="2">
                <v-icon left>mdi-plus-thick</v-icon>
                NUEVA ÁREA
              </v-btn>
            </template>
            <v-card class="modern-dialog">
              <v-card-title class="dialog-header">
                <v-icon color="white" class="mr-2">mdi-collage</v-icon>
                <span class="dialog-title">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text class="dialog-content">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.nombreArea"
                        label="Nombre del Área"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                        placeholder="Ingrese el nombre del área"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="close" class="cancel-btn">
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="save"
                  :disabled="!editedItem.nombreArea"
                  class="save-btn"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Área"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
      </div>

      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="areas"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontró su búsqueda
              </v-alert>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <div class="action-icons">
                <v-icon
                  class="action-icon edit-icon"
                  @click="editItem(item)"
                  title="Editar Área"
                >
                  mdi-pencil
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      areas: [],
      dialog: false,
      headers: [
        {
          text: "ID",
          align: "center",
          value: "idArea",
          class: "column",
        },
        {
          text: "Área",
          value: "nombreArea",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        idArea: "",
        nombreArea: "",
      },
      editedIndex: -1,
      editedItem: {
        idArea: "",
        nombreArea: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Área" : "Editar Área";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerAreas();
  },

  methods: {
    // Metodo para obtener los areas
    obtenerAreas() {
      axios.get(`${env.endpoint}user/areas`).then((res) => {
        this.areas = res.data;
      });
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.areas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      if (this.editedIndex > -1) {
        const editarArea = new FormData();
        editarArea.append("idArea", this.editedItem.idArea);
        editarArea.append("nombreArea", this.editedItem.nombreArea);

        axios
          .post(`${env.endpoint}user/modificar_area`, editarArea, {})
          .then((res) => {
            this.editarinventario = res.data;
            this.obtenerAreas();
          });
        swal({
          title: "Área Modificada",
          text: "Área modificada satisfactoriamente",
          icon: "success",
          buttons: ["Cancelar", true],
        });
      } else {
        const nuevaArea = new FormData();
        nuevaArea.append("nombreArea", this.editedItem.nombreArea);

        axios
          .post(`${env.endpoint}user/create_area`, nuevaArea, {})
          .then((res) => {
            this.inventario = res.data;
            this.obtenerAreas();
          });
        swal({
          title: "Área creada",
          text: "Área creada satisfactoriamente",
          icon: "success",
          buttons: ["Cancelar", true],
        });
      }
      this.close();
    },
  },
};
</script>

<style scoped>
/* ===== CONTAINER PRINCIPAL ===== */
.areas-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 2rem;
}

.unified-container {
  max-width: 1800px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.title-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.title-text {
  display: flex;
  flex-direction: column;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 1rem;
  margin: 0.25rem 0 0 0;
  opacity: 0.9;
  font-weight: 400;
}

.action-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.create-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0.75rem 1.5rem !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.create-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.search-card {
  max-width: 400px;
  margin: 0 auto;
}

.search-field {
  background: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
}

.table-card {
  background: white;
  border-radius: 0;
  overflow: hidden;
}

.modern-table {
  background: white;
}

.modern-table >>> .v-data-table__wrapper {
  border: none;
  border-radius: 0;
}

.modern-table >>> .v-data-table-header {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 1rem 0.75rem !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #f8fafc;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #eff6ff !important;
  transform: none;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  padding: 1rem 0.75rem !important;
  color: #374151 !important;
  font-size: 0.875rem !important;
}

/* ===== ACTION ICONS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.action-icon {
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1.25rem !important;
  padding: 0.25rem;
  border-radius: 4px;
}

.edit-icon {
  color: #3b82f6 !important;
}

.edit-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1);
}

/* ===== TABLE FOOTER ===== */
.modern-table >>> .v-data-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  padding: 1rem;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-size: 0.875rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-size: 0.875rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  color: #6b7280 !important;
}

/* ===== DIALOG STYLES ===== */
.modern-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  padding: 1.5rem !important;
}

.dialog-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
}

.dialog-content {
  padding: 2rem !important;
}

.modern-field {
  margin-bottom: 1rem !important;
}

.modern-field >>> .v-input__control {
  min-height: 48px !important;
}

.modern-field >>> .v-field {
  border-radius: 8px !important;
}

.dialog-actions {
  padding: 1rem 2rem 2rem 2rem !important;
  background: #f8fafc;
}

.cancel-btn {
  margin-right: 1rem !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.save-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0.75rem 2rem !important;
}

/* ===== SNACKBAR ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .areas-container {
    padding: 1rem;
  }

  .header-section {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    gap: 0.75rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .search-section {
    padding: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .action-icons {
    flex-direction: column;
    gap: 0.25rem;
  }

  .action-icon {
    width: 28px;
    height: 28px;
    font-size: 1rem !important;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.25rem;
  }

  .subtitle {
    font-size: 0.875rem;
  }

  .create-btn {
    padding: 0.5rem 1rem !important;
    font-size: 0.875rem !important;
  }
}
</style>
